import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { AppConstants } from 'src/app/app/helpers/app-constants';
import { AppFacade } from 'src/app/app/store/app.facade';
import { DynamicUiService } from 'src/app/dynamic-ui/services/dynamic-ui.service';
import { EnvironmentDisplay, EnvironmentDisplayService } from '../../services/environment-display.service';

@Component({
  standalone: false,
    selector: 'app-simple-header',
    templateUrl: './simple-header.component.html',
    styleUrls: ['./simple-header.component.scss'],
})
export class SimpleHeaderComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    title$ = this.appFacade.title$;
    clubName: string = '';
    anlassName: string = '';
    subTitle: string = '';
    environmentDisplay$: Observable<EnvironmentDisplay>;

    constructor(
        private appFacade: AppFacade,
        private dynamicService: DynamicUiService,
        environmentDisplayService: EnvironmentDisplayService
    ) {
        this.environmentDisplay$ = environmentDisplayService.display$;
    }

    ngOnInit(): void {
        this.dynamicService.GetValueAsObservable(AppConstants.dataStoreCurrentClubName, [])
            .pipe(takeUntil(this.destroy$))
            .subscribe(c => {
                this.clubName = c;
                this.setSubTitle();
            });
        this.dynamicService.GetValueAsObservable(AppConstants.dataStoreCurrentAnlassName, [])
            .pipe(takeUntil(this.destroy$))
            .subscribe(c => {
                this.anlassName = c;
                this.setSubTitle();
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setSubTitle() {
        this.subTitle = ((this.clubName) ? this.clubName : "") + ((this.anlassName) ? " - " + this.anlassName : "");
    }
}
